import React, { useContext, useState } from "react"
import styles from "./LanguageSwitcher.module.scss"
import classNames from "classnames"
import { useIntl } from "gatsby-plugin-intl"
import { Locale } from "../../../types/Locale.enum"
import { MutedLocalesContext } from "../../../templates/blog-post/blog-post"

interface LanguageSwitcher {
	children?: any
	className?: string
	location: any
	[x: string]: any
}

export const languages = [Locale.EN, Locale.AR]

const LanguageSwitcher: React.FC<LanguageSwitcher> = ({
	className,
	children,
	location,
	...other
}) => {
	const intl = useIntl()
	const { locale } = intl
	const href = (location && location.pathname) || `/`
	const mutedLocales = useContext(MutedLocalesContext)
	const filteredLocales =
		!mutedLocales || mutedLocales.length === 0
			? languages
			: languages.filter(locale => !mutedLocales.includes(locale))


	return (
		<ul className={styles.list}>
			{filteredLocales.map((language, index) => (
				<li
					className={classNames(styles.listItem, {
						[styles.listItemCurrent]: language === locale,
					})}
					key={index}
				>
					<a className={styles.listLink}
						href={
							language === locale ? href : href.replace(locale, language)
						}
						tabIndex={1}
						aria-label={intl.formatMessage({ id: `header.switcher.${language}` })}
					>
						<span>
							{intl.formatMessage({ id: `header.switcher.${language}` })}
						</span>
					</a>
				</li>
			))}
		</ul>
	)
}

export default LanguageSwitcher
